import { useScroll, useTransform } from "framer-motion";

export function useStickyPreviewMotion(scrollRef) {
    const STICKY_TOP = 24;
    const BOTTOM_PADDING = 24;
    const HEADER_TOTAL = 75; // 20 top + 35 header + 20 gap
    const FUDGE = -2;

    const { scrollY } = useScroll({
        container: scrollRef,
    });

    const rawHeight = useTransform(scrollY, (y) => {
        const viewportHeight = window.innerHeight;

        // 🔑 top dinámico continuo
        const effectiveTop = Math.max(
            HEADER_TOTAL - y,
            STICKY_TOP
        );

        const available =
            viewportHeight -
            effectiveTop -
            BOTTOM_PADDING -
            FUDGE;

        return Math.max(available, 0);
    });

    return rawHeight
}
